import { Injectable } from '@angular/core';
import { ConfiguracionInicialService } from './configuracioninicial.service';
import { ComunicacionapiService } from './comunicacionapi.service';
import { Constantes } from '../models/modules/Constantes';
import { Observable } from 'rxjs/internal/Observable';
import { Listas } from '../models/generic/Listas';
import { GestionAfiliado } from '../models/generic/GestionAfiliado';
import { GestionAfiliado_Cartera } from '../models/generic/GestionAfiliado_Cartera';
import { Estados } from '../models/generic/Estados';
import { ProductosEdades } from '../models/generic/ProductosEdades';

@Injectable({
  providedIn: 'root'
})
export class GestionAfiliadoService {
  
  ListaAfiliados: GestionAfiliado[] = [];
  ListaAfiliadosCartera: GestionAfiliado_Cartera[] = [];
  ListasConfiguracion: Listas[] = [];
  
  constructor(private configInicial: ConfiguracionInicialService,
    private comunicacionapiService: ComunicacionapiService) {
      
  }

  Consultar(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarDetalle(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTARDETALLE()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarDatosAdicionales(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTARDATOSADICIONALES()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarMovimientos(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTARMOVIMIENTOS()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarCartera(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTAR_CARTERA()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarListas(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTAR_LISTAS_CONFIGURACION()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  Afiliado_Notificar(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_NOTIFICARAFILIAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ActualizarEstado(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_ACTUALIZAR_ESTADO()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarProductos(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTAR_PRODUCTO_CONFIGURACION()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarProductosCompletos(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTAR_PRODUCTO_CONFIGURACION_COMPLETOS()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarProductosEdades(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTAR_PRODUCTO_EDADES_CONFIGURACION()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarEstados(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTAR_PRODUCTO_ESTADOS_CONFIGURACION()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarParentescos(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTAR_PRODUCTO_PARENTESCOS_CONFIGURACION()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarEdicion(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTAR_EDICION_ID()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarEdicionBeneficiario(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTAR_EDICION_BENEFICIARIO_ID()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarMarcas(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTAR_MARCAS()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarMarcasReferencias(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTAR_MARCAS_REFERENCIAS()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarDocumentos(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_CONSULTAR_DOCUMENTOS()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  DescargarDocumento(parametros: any): any {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_DESCARGAR_DOCUMENTOS()}`;
    return this.comunicacionapiService.PostDescarga(urlServicio, parametros);
  }
  EliminarAfiliacion(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.GESTIONAFILIADOS_ELIMINAR_AFILIACION()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
}
